import React from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

const RadioDescriptionWidget = ({
  id,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  options,
}) => {
  const enumOptions =
    options.enumOptions || options["ui:options"]?.enumOptions || [];
  const enumDisabled = options.enumDisabled || [];

  const fieldDescription =
    options["ui:options"]?.description || options.description;

  return (
    <FormControl component="fieldset" fullWidth margin="normal">
      {/* Field Label */}
      {label && (
        <Typography variant="h4">
          {label}
          {required ? " *" : ""}
        </Typography>
      )}

      {fieldDescription && (
        <Typography variant="body2" color="default.light" mb={2}>
          {fieldDescription}
        </Typography>
      )}

      <RadioGroup
        name={id}
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
      >
        {enumOptions.map((option) => {
          const isDisabled = enumDisabled.includes(option.value);
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  disabled={disabled || readonly || isDisabled}
                  color="primary"
                />
              }
              label={
                <>
                  <Typography variant="h6">{option.label}</Typography>
                  {/* Option-specific description */}
                  {option?.schema?.description && (
                    <Typography
                      variant={
                        option.label === "Credit Card"
                          ? "h6"
                          : "body2"
                      }
                      color={
                        option.label === "Credit Card"
                          ? "default.dark"
                          : "default.light"
                      }
                    >
                      {option?.schema?.description}
                    </Typography>
                  )}
                </>
              }
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioDescriptionWidget;
